export default __webpack_public_path__ + "178c0d6f6fda127b60a0ad707a30d193.png";